<template>
  <div class="color-picker">
    <h4 v-if="title" class="color-picker__title">{{ title }} - choice</h4>
    <ul class="color-picker__colors">
      <li
        v-for="(color, index) in colors"
        :key="index"
        class="color-picker__color"
      >
        <color
          :key="index"
          :id="color.Id"
          :hex="color.Hex"
          :name="color.Name"
          :type="color.Type"
          :children="color.Items"
          @mouseover="isActive = true"
          @mouseleave="isActive = false"
        />
      </li>
    </ul>
  </div>
</template>

<script>

import Vue from 'vue'
import Component from "vue-class-component"
import { Prop } from 'vue-property-decorator'
import Color from '@/components/color-picker/color/color.vue'
//
@Component({
  components: {
    'color': Color
  },
})
export default class ColorPicker extends Vue {
  @Prop() colors
  @Prop() title

  mounted() {
  }


}
</script>
